export default "__VITE_ASSET__0821a662__$_?nuxt_component=async&nuxt_component_name=SvgoFilmchallenge__"